import useCommon from "@/shared/hooks/useCommon";
import useOnboardingInit from "@/shared/mutations/onboarding/useOnboardingInit";
import { Branch } from "@/shared/utils/interfaces";
import { useState } from "react";
import Button from "../Button/Button";
import BranchSelect from "../Select/BranchSelect";
import Modal, { ModalProps } from "./Modal";
import ModalTitle from "./ModalTitle";

export interface SoundModalProps extends ModalProps {}

const OnboardingCreateModal = ({ ...props }: SoundModalProps) => {
  const mutate = useOnboardingInit();
  const [branch, setBranch] = useState<Branch>(undefined);
  const t = useCommon();

  return (
    <Modal width="40rem" {...props}>
      <ModalTitle mb="2rem" p="0">
        {t("onboardingCreate")}
      </ModalTitle>
      <BranchSelect
        showAllBox={false}
        onChange={(branch) => {
          setBranch(branch.branch);
        }}
      />
      <div className="mt-[2rem]">
        <Button
          onClick={() =>
            mutate.mutateAsync(branch.id).then(() => props.onExit())
          }
          isPending={mutate.isPending}
          isDisabled={!branch}
        >
          {t("save")}
        </Button>
      </div>
    </Modal>
  );
};

export default OnboardingCreateModal;
